/* eslint-disable react/destructuring-assignment */
// @ts-nocheck
import React, { Suspense, useCallback, useLayoutEffect, useRef, useState, } from 'react';
import { makeStyles } from '@material-ui/core';
import { useInView } from 'react-intersection-observer';
const useStyles = makeStyles(() => ({
    root: {},
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
}));
export const LazyWrapper = ({ width, height: initialHeight, children, options = {}, trackHeight, }) => {
    const classes = useStyles();
    const { ref, inView } = useInView(options);
    const childRef = useRef();
    const [height, setHeight] = useState(initialHeight);
    const calculateSize = useCallback((entries) => {
        const { height: ch } = entries[0].contentRect;
        setHeight(ch);
    }, []);
    /**
     * ? INFO(suley)
     * It is not good to ignoring typescript. However,
     * to deploy package successfully, we needed to ignore
     * ts. Otherwise, we will face ResizeObserver is undefined error
     * */
    // @ts-ignore
    const observer = React.useRef(new ResizeObserver(calculateSize));
    useLayoutEffect(() => {
        if (inView && trackHeight) {
            observer.current.observe(childRef.current);
            return () => {
                observer.current.unobserve(childRef.current);
            };
        }
    }, [inView, trackHeight]);
    return (React.createElement("div", { className: classes.root, ref: ref, style: { position: 'relative', width, height } },
        React.createElement("div", { className: classes.container, ref: childRef }, inView && children)));
};
export const LazyWrapperSuspense = (props) => (React.createElement(Suspense, { fallback: React.createElement("div", { style: { width: props.width, height: props.height } }) },
    React.createElement(LazyWrapper, Object.assign({}, props))));
